import '../assets/css/tables.css'
import { getSQLDateFormat } from '../utilities/general-utils'

const DebtPaymentTotals = (props) => {
    return (
        <div>
            <h3 className="text-center">Totals</h3>
            <div className="responsive-table-wrap">
                <table
                    className={`standardTable ${props.className} spc-m-x-auto spc-m-t-2`}
                >
                    <thead>
                        <tr>
                            <th style={{width: "20%"}}>Interest Paid</th>
                            <th style={{width: "20%"}}>Total Paid</th>
                            <th style={{width: "20%"}}>Payments</th>
                            <th style={{width: "20%"}}>Years</th>
                            <th style={{width: "20%"}}>Final Payment</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-center">
                                $
                                {parseFloat(
                                    props.data.reduce(
                                        (acc, row) => acc + row.interestPaid,
                                        0
                                    )
                                ).toFixed(2)}
                            </td>
                            <td className="text-center">
                                $
                                {parseFloat(
                                    props.data.reduce(
                                        (acc, row) => acc + row.totalPayment,
                                        0
                                    )
                                ).toFixed(2)}
                            </td>
                            <td className="text-center">
                                {props.data.length}
                            </td>
                            <td className="text-center">
                                {parseFloat(props.data.length / 12).toFixed(2)}
                            </td>
                            <td className="text-center">
                                {getSQLDateFormat(
                                    props.data[props.data.length - 1].date
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DebtPaymentTotals